import { Entidade } from "./../../../modules/basico/entidade/entidade";
import { LayoutCss } from "./../../../modules/basico/layout-css/layout-css";
import { UnidadeGestora } from "./../../../modules/basico/unidade-gestora/unidade-gestora";
import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../common/shared.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-module",
  templateUrl: "./module.component.html",
  styleUrls: ["./module.component.css"],
})
export class ModuleComponent implements OnInit {
  unidadesGestoras: UnidadeGestora[] = [];
  layout: LayoutCss;
  entidade: Entidade;

  constructor(private sharedService: SharedService, private router: Router) {}

  ngOnInit() {
    this.unidadesGestoras = this.sharedService.usuario.unidadesGetoras;
    this.layout = this.sharedService.layout;
    this.entidade = this.sharedService.usuario.entidade;
  }

  setUnidade(unidade: UnidadeGestora) {
    this.sharedService.unidade = unidade;
    this.router.navigate(["/"]);
  }
}
